import { Course, University, StudentReview } from '../types';

export const DEMO_COURSES: Course[] = [
  {
    id: 'cs',
    name: 'BS Computer Science (CS)',
    code: 'CS',
    description: 'Comprehensive Computer Science program covering algorithms, data structures, software engineering, databases, and computer networks. Students gain expertise in multiple programming languages.',
    duration: '4 years',
    level: 'Undergraduate',
    category: 'Computer Science',
    prerequisites: ['Intermediate with minimum 50% (Pre-Engineering/ICS)', 'Mathematics required'],
    benefits: [
      'Strong foundation in computer science fundamentals',
      'Expertise in multiple programming languages (Python, Java, C++)',
      'Hands-on experience with software development projects',
      'Career opportunities in software development and research'
    ],
    fees: 12000,
    university_id: 'aziz-edu-1',
    image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    focus_area: 'Algorithms, data structures, software engineering, databases, computer networks'
  },
  {
    id: 'se',
    name: 'BS Software Engineering (SE)',
    code: 'SE',
    description: 'Industry-focused Software Engineering program emphasizing software design patterns, agile methodologies, DevOps practices, and cloud computing. Students work on real-world projects.',
    duration: '4 years',
    level: 'Undergraduate',
    category: 'Software Engineering',
    prerequisites: ['Intermediate with minimum 50% (Pre-Engineering/ICS)', 'Mathematics required'],
    benefits: [
      'Professional software development skills',
      'Experience with agile and DevOps practices',
      'Cloud computing and microservices architecture knowledge',
      'Career opportunities in software companies and startups'
    ],
    fees: 12000,
    university_id: 'aziz-edu-1',
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    focus_area: 'Software design patterns, agile methodologies, DevOps, cloud computing'
  },
  {
    id: 'ai',
    name: 'BS Artificial Intelligence (AI)',
    code: 'AI',
    description: 'Cutting-edge AI program covering machine learning, deep learning, natural language processing, computer vision, and robotics. Students work with TensorFlow and PyTorch.',
    duration: '4 years',
    level: 'Undergraduate',
    category: 'Artificial Intelligence',
    prerequisites: ['Intermediate with minimum 55% (Pre-Engineering/ICS)', 'Mathematics and Physics required'],
    benefits: [
      'Expertise in machine learning and deep learning',
      'Hands-on experience with AI frameworks',
      'Research opportunities in AI and robotics',
      'Career opportunities in AI research and development'
    ],
    fees: 12000,
    university_id: 'aziz-edu-1',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    focus_area: 'Machine learning, deep learning, NLP, computer vision, robotics'
  },
  {
    id: 'cyber',
    name: 'BS Cybersecurity',
    code: 'CYBER',
    description: 'Specialized Cybersecurity program focusing on network security, cryptography, ethical hacking, digital forensics, and information assurance with hands-on security tools.',
    duration: '4 years',
    level: 'Undergraduate',
    category: 'Cybersecurity',
    prerequisites: ['Intermediate with minimum 50% (Pre-Engineering/ICS)', 'Mathematics required'],
    benefits: [
      'Comprehensive knowledge of cybersecurity principles',
      'Hands-on ethical hacking and penetration testing skills',
      'Industry-recognized security certifications preparation',
      'Career opportunities in cybersecurity and information assurance'
    ],
    fees: 12000,
    university_id: 'aziz-edu-1',
    image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    focus_area: 'Network security, cryptography, ethical hacking, digital forensics'
  },
  {
    id: 'ds',
    name: 'BS Data Science',
    code: 'DS',
    description: 'Interdisciplinary Data Science program combining statistics, computer science, and domain expertise. Students learn data analysis, visualization, and predictive modeling.',
    duration: '4 years',
    level: 'Undergraduate',
    category: 'Data Science',
    prerequisites: ['Intermediate with minimum 50% (Pre-Engineering/ICS/Pre-Medical)', 'Mathematics or Statistics required'],
    benefits: [
      'Strong statistical and analytical foundation',
      'Expertise in data visualization and storytelling',
      'Experience with big data technologies (Hadoop, Spark)',
      'Career opportunities in data analysis and business intelligence'
    ],
    fees: 12000,
    university_id: 'aziz-edu-1',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    focus_area: 'Statistics, data analysis, visualization, big data, predictive modeling'
  },
  {
    id: 'cloud',
    name: 'BS Cloud Computing',
    code: 'CLOUD',
    description: 'Specialized Cloud Computing program covering cloud architecture, virtualization, containerization, serverless computing, and cloud security with AWS, Azure, and GCP certifications.',
    duration: '4 years',
    level: 'Undergraduate',
    category: 'Cloud Computing',
    prerequisites: ['Intermediate with minimum 50% (Pre-Engineering/ICS)', 'Mathematics required'],
    benefits: [
      'Expertise in major cloud platforms (AWS, Azure, GCP)',
      'Container orchestration with Kubernetes',
      'Cloud security and compliance knowledge',
      'Career opportunities in cloud architecture and DevOps'
    ],
    fees: 12000,
    university_id: 'aziz-edu-1',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    focus_area: 'Cloud architecture, virtualization, containerization, serverless computing'
  }
];

export const DEMO_UNIVERSITIES: University[] = [
  {
    id: 'aziz-edu-1',
    name: 'Aziz Edu University of Technology',
    location: 'Karachi, Pakistan',
    description: 'Leading computer science and technology university offering cutting-edge programs in AI, cybersecurity, data science, and software engineering. Established in 2010 with state-of-the-art facilities.',
    established: 2010,
    ranking: 1,
    acceptance_rate: 40,
    courses: ['cs', 'se', 'ai', 'cyber', 'ds', 'cloud', 'it', 'robotics'],
    image: 'https://images.unsplash.com/photo-1562774053-701939b7486f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    website: 'https://azizedu.edu.pk',
    contact_info: {
      city_office: {
        address: 'ST-2/A, Sector 15, Korangi Industrial Area, Karachi, Pakistan',
        phone: '(92-21) 3500-1234',
        fax: '(92-21) 3500-1235'
      },
      main_campus: {
        address: 'ST-2/A, Sector 15, Korangi Industrial Area, Karachi, Pakistan',
        phone: '(92-21) 3500-1234',
        fax: '(92-21) 3500-1235'
      },
      emails: {
        admissions: 'admissions@azizedu.edu.pk',
        general: 'info@azizedu.edu.pk'
      }
    },
    admission_schedule: {
      application_deadline: 'July 31, 2026',
      admission_test_dates: 'August 10, 2026',
      result_announcement: 'August 20, 2026',
      orientation_session: 'September 10, 2026'
    }
  }
];

export const DEMO_REVIEWS: StudentReview[] = [
  {
    id: 'review-1',
    student_name: 'Ahmed Hassan',
    course_id: 'cs',
    rating: 5,
    review_text: 'Excellent Computer Science program with outstanding faculty and modern labs. The curriculum is industry-relevant and the hackathons provide great practical experience. Highly recommend for aspiring software engineers!',
    date: '2024-01-15',
    is_approved: true
  },
  {
    id: 'review-2',
    student_name: 'Fatima Khan',
    course_id: 'ai',
    rating: 5,
    review_text: 'The AI program at Aziz Edu is world-class. Working with TensorFlow and PyTorch on real projects has prepared me well for my career. The research opportunities are amazing!',
    date: '2024-01-10',
    is_approved: true
  },
  {
    id: 'review-3',
    student_name: 'Usman Malik',
    course_id: 'cyber',
    rating: 5,
    review_text: 'Best cybersecurity program in Pakistan! The ethical hacking labs and penetration testing courses gave me hands-on experience. Already got certified and placed at a top firm.',
    date: '2024-01-05',
    is_approved: true
  },
  {
    id: 'review-4',
    student_name: 'Ayesha Rahman',
    course_id: 'ds',
    rating: 4,
    review_text: 'Great Data Science program with strong statistics foundation. The big data technologies course was challenging but rewarding. Excellent career support and internship opportunities.',
    date: '2023-12-28',
    is_approved: true
  },
  {
    id: 'review-5',
    student_name: 'Hassan Sheikh',
    course_id: 'se',
    rating: 5,
    review_text: 'Software Engineering program exceeded my expectations. Agile methodologies, DevOps practices, and cloud computing courses prepared me for the industry. Got placed at Systems Limited before graduation!',
    date: '2023-12-20',
    is_approved: true
  },
  {
    id: 'review-6',
    student_name: 'Zara Ali',
    course_id: 'cloud',
    rating: 5,
    review_text: 'Cloud Computing program is fantastic! Got AWS and Azure certified during my studies. The hands-on labs with Kubernetes and Docker were invaluable. Now working as a Cloud Engineer.',
    date: '2023-12-15',
    is_approved: true
  }
];
